import React from "react";
import {
  CheckCircle2,
  ShieldCheck,
  Users,
  Timer,
  Sparkles,
  HandHeart,
  MapPin,
} from "lucide-react";

const reasons = [
  {
    icon: Timer,
    title: "Speed without shortcuts",
    desc: "Most roles filled within 7–14 days, with quality checked twice.",
  },
  {
    icon: HandHeart,
    title: "People-first, always",
    desc: "Real conversations, empathetic matching — not transactional resume pushing.",
  },
  {
    icon: ShieldCheck,
    title: "Startup-savvy HR",
    desc: "We understand early-stage reality — lean budgets, fast pivots, culture first.",
  },
  {
    icon: Users,
    title: "End-to-end partner",
    desc: "From sourcing to onboarding and retention, we stay with you past the offer.",
  },
  {
    icon: Sparkles,
    title: "Candidate experience",
    desc: "Every applicant leaves informed and respected — protecting your employer brand.",
  },
  {
    icon: CheckCircle2,
    title: "Transparent, flexible",
    desc: "Simple engagement models and clear deliverables. No surprise invoices.",
  },
];

export default function WhyChooseUs() {
  return (
    <section id="why-us" className="py-20 md:py-28" data-testid="why-us-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl">
          <span className="uppercase text-xs tracking-[0.22em] font-bold text-brand-primary">
            Why Choose Us
          </span>
          <h2 className="mt-3 font-heading font-medium text-3xl sm:text-4xl lg:text-5xl tracking-tight">
            Warm, honest HR — delivered with expertise.
          </h2>
          <div
            className="mt-5 inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-white border border-brand-border text-sm text-brand-ink shadow-sm"
            data-testid="why-us-pan-india"
          >
            <MapPin size={14} className="text-brand-primary" />
            <span className="font-semibold">Pan-India</span>
            <span className="text-brand-muted">· Worked with startups across India</span>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map(({ icon: Icon, title, desc }, i) => (
            <div
              key={title}
              className="rounded-2xl p-6 bg-white border border-brand-border hover:border-brand-primary/40 hover:shadow-md transition-all"
              data-testid={`why-us-item-${i}`}
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl bg-brand-soft grid place-items-center text-brand-primary shrink-0">
                  <Icon size={18} />
                </div>
                <div>
                  <h3 className="font-heading text-lg font-medium">{title}</h3>
                  <p className="mt-1.5 text-sm text-brand-muted leading-relaxed">{desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
